import gql from "graphql-tag";

export const GetTipoDocQuery = gql`
    query Data($codigo:String){
        tipoDocumentoId(codigo:$codigo){
            codigo
            descripcion
        }
    }
`;